import React from 'react'
import PropTypes from 'prop-types'
import GlobalFilter from './GlobalFilter'
import Table from 'react-bootstrap/Table'

const TableGroup = (props) => {
  const {
    getTableProps, getTableBodyProps, headerGroups, page, prepareRow,
    state, visibleColumns, preGlobalFilteredRows, setGlobalFilter,
    onShowEditVehicleModal
  } = props

  return (
    <Table hover {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => {
              return (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>{column.render('Header')}
                  <span>
                    {column.isSorted ? (column.isSortedDesc ? ' 🔽 ' : ' 🔼 ') : ' '}
                  </span>
                  {/* <div>{column.canFilter ? column.render('Filter') : null}</div> */}
                </th>
              )
            })}
          </tr>
        ))}
        <tr>
          <th
            colSpan={visibleColumns.length}
            style={{
              textAlign: 'left'
            }}
          >
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={state.globalFilter}
              setGlobalFilter={setGlobalFilter}
            />
          </th>
        </tr>

      </thead>
      <tbody {...getTableBodyProps()}>
        {page.map((row, i) => {
          prepareRow(row)
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <td
                  {...cell.getCellProps()}
                  style={{ cursor: 'pointer' }}
                  onClick={() => onShowEditVehicleModal(row)}
                       >
                  {cell.render('Cell')}
                       </td>
              })}
            </tr>
          )
        })}
      </tbody>
    </Table>
  )
}

export default TableGroup

TableGroup.propTypes = {
  getTableProps: PropTypes.func,
  getTableBodyProps: PropTypes.func,
  headerGroups: PropTypes.array,
  page: PropTypes.array,
  prepareRow: PropTypes.func,
  state: PropTypes.object,
  visibleColumns: PropTypes.array,
  preGlobalFilteredRows: PropTypes.array,
  setGlobalFilter: PropTypes.func,
  onShowEditVehicleModal: PropTypes.func
}
